import {
    getOwnershipTypes,
    deleteOwnershipType,
    createOwnershipType,
    updateOwnershipType
} from '../../../services/OwnershipTypeService';
import {
    CONFIRMED_GET_OWNERSHIP_TYPES
} from './OwnershipTypeTypes';

export function getOwnershipTypesAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'OWNERSHIP_TYPES_LOADING' });
        getOwnershipTypes(currentPage, pageSize, searchTerm, filterQuery)
            .then((response) => {
                dispatch(confirmedGetOwnershipTypesAction(response.data.data));
            })
            .catch(() => {
                dispatch(confirmedGetOwnershipTypesAction({ rows: [], count: 0, pages: 1 }));
            });
    };
}

export function confirmedGetOwnershipTypesAction(data) {
    return {
        type: CONFIRMED_GET_OWNERSHIP_TYPES,
        payload: data,
    };
}

export function deleteOwnershipTypeAction(id, history) {
    return (dispatch, getState) => {
        return deleteOwnershipType(id).then((response) => {
            return response;
        });
    };
}

export function createOwnershipTypeAction(data) {
    return () => {
        return createOwnershipType(data).then((response) => {
            return response;
        });
    };
}

export function updateOwnershipTypeAction(id, data) {
    return () => {
        return updateOwnershipType(id, data).then((response) => {
            return response;
        });
    };
}

